import { EntityId } from '../../EntityId';
import { TeamArmy } from './TeamArmy';
import { Draw } from './Draw';

export interface DraftTeam extends EntityId<string> {
  leadId: number | null;
  state: DraftTeamCreationState;
  draw: Draw | null;
  teamArmies: Array<TeamArmy>;
}

export enum DraftTeamCreationState {
  pending = 0,
  created = 1,
}
